import { getFirestore, enableIndexedDbPersistence, getDoc, doc, setDoc } from 'firebase/firestore';
import * as firebase from 'firebase/app'
import * as firebaseAuth from "firebase/auth";
import { Capacitor } from '@capacitor/core';
import { unregisterResourceSnapshotListener } from './resources';
import { unregisterEventSnapshotListener } from './events';
import { unregisterClientSnapshotListener } from './clients';
import { getUser, registerUserSnapshotListener, unregisterUserSnapshotListener } from './users';
import { unregisterSmsTemplateSnapshotListener } from './smsTemplates';
import { unregisterServiceSnapshotListener } from './services';
import { sendEmailVerification } from 'firebase/auth';
import { getStoreValue, setStoreValue } from '../storage';
import { unregisterDocumentTemplateSnapshotListener } from './documentTemplates';
import { unregisterSettingsSnapshotListener } from './settings';
import { unregisterWorkspaceSnapshotListener } from './workspace';
import { Device } from '@capacitor/device';
import { unregisterSmsGroupSnapshotListener } from './smsGroup';
import { unregisterVersionSnapshotListener } from './version';


const firebaseConfig = {
    apiKey: "AIzaSyArB7sFPilnXVQqK24XG8o_HuuIxQctig8",
    authDomain: "egabinet-367f8.firebaseapp.com",
    databaseURL: "https://egabinet-367f8-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "egabinet-367f8",
    storageBucket: "egabinet-367f8.appspot.com",
    messagingSenderId: "932047168195",
    appId: "1:932047168195:web:39d2266aac955ca6953876"
};
var dbPersistence: boolean | undefined = undefined;
export const app = firebase.initializeApp(firebaseConfig);


export const db = getFirestore(app);

enableIndexedDbPersistence(db).then(() => {
    dbPersistence = true;
    sendPersistance();

})
    .catch((err) => {
        dbPersistence = false;
        sendError("persistence: " + err.code + " -> " + err.message);
        sendPersistance();
    });


export var auth: firebaseAuth.Auth;
if (Capacitor.isNativePlatform()) {
    auth = firebaseAuth.initializeAuth(app, {
        persistence: firebaseAuth.indexedDBLocalPersistence
    })

} else {
    auth = firebaseAuth.getAuth();
}

var companyId = "???";
export function getCompanyId() {
    return companyId;
}


var user: firebaseAuth.User | null = null;

const errorListeners: CallableFunction[] = [];

const persistenceListeners: CallableFunction[] = [];

const authStateChangeListeners: CallableFunction[] = [];



export function sendError(msg: string) {
    errorListeners.forEach(callback => {
        callback(msg);
    });
}

function sendPersistance() {
    persistenceListeners.forEach(callback => {
        callback(dbPersistence);
    });
}


export function getCurrentUserUID() {
    return auth.currentUser?.uid;
}

export function getCurrentUserAuth() {
    return auth.currentUser;
}

export function sendEmailVerificationToCurrenUser() {
    if (auth.currentUser !== null) {
        sendEmailVerification(auth.currentUser);
    }
}


export function getCurrentUser() {
    return getUser(getCurrentUserUID() + "");
}

// export async function checkCompany(id: string) {
//     try {
//         const docSnap = await getDoc(doc(db, "companies", id));
//         if (docSnap.exists()) {
//             return true;
//         } else {
//             logoutUser();
//         }
//     } catch (error) {
//         logoutUser();
//     }
//     return false;
// }

export async function loginUser(email: string, pass: string) {
    try {
        //await setStoreValue("workspace", workspace);
        const res = await firebaseAuth.signInWithEmailAndPassword(auth, email, pass);
        return true;
        //return await checkCompany(workspace);

    } catch (error) {
        return false;
    }
}

export async function passwordReset(email: string) {
    try {
        const res = await firebaseAuth.sendPasswordResetEmail(auth, email);
        return true;
    } catch (error) {
        return false;
    }
}

export async function logoutUser() {
    try {
        await removeDevicePushId();
        await unregisterResourceSnapshotListener();
        await unregisterEventSnapshotListener();
        await unregisterClientSnapshotListener();
        await unregisterUserSnapshotListener();
        await unregisterSmsTemplateSnapshotListener();
        await unregisterServiceSnapshotListener();
        await unregisterVersionSnapshotListener();
        await unregisterDocumentTemplateSnapshotListener();
        await unregisterSettingsSnapshotListener();
        await unregisterWorkspaceSnapshotListener();
        await unregisterSmsGroupSnapshotListener();
        //companyId = "???";
        const res = await firebaseAuth.signOut(auth);
        return res;
    } catch (error) {
        return false;
    }
}

export async function changeWorkspace(workspace: string, force=false) {
    try {
        if (workspace.length > 1 && (companyId !== workspace || force)) {
            await unregisterResourceSnapshotListener();
            await unregisterEventSnapshotListener();
            await unregisterClientSnapshotListener();
            await unregisterUserSnapshotListener();
            await unregisterSmsTemplateSnapshotListener();
            await unregisterServiceSnapshotListener();
            await unregisterVersionSnapshotListener();
            await unregisterDocumentTemplateSnapshotListener();
            await unregisterSettingsSnapshotListener();
            await unregisterWorkspaceSnapshotListener();
            await unregisterSmsGroupSnapshotListener();
            await setStoreValue("workspace", workspace);
            companyId = workspace;
            registerUserSnapshotListener((user: any) => {
                authStateChangeListeners.forEach(callback => {
                    callback(user);
                });
            });
        }
    } catch (error) {
        console.log(error);
    }
}



export function addOnAuthStateChangedListener(listener: any) {
    authStateChangeListeners.push(listener);
    if (authStateChangeListeners.length === 1) {
        //console.log('register authStateChangeListeners');
        auth.onAuthStateChanged((user) => {
            //console.log("authStateChangeListeners", user);
            if (user !== null && user !== undefined) {
                getStoreValue("workspace").then(async v => {
                    if (v !== undefined && v !== null && v !== "") {
                        companyId = v;
                        //if (await checkCompany(companyId)) {
                        if (getCurrentUserAuth()?.emailVerified) {
                            registerUserSnapshotListener((user: any) => {
                                authStateChangeListeners.forEach(callback => {
                                    callback(user);
                                });
                            });
                        }else{
                            authStateChangeListeners.forEach(callback => {
                                callback(user);
                            });
                        }

                        //}
                    } else {
                        //getWorkspaces and choose one
                        authStateChangeListeners.forEach(callback => {
                            callback(user);
                        });
                    }
                })
            } else {
                authStateChangeListeners.forEach(callback => {
                    callback(user);
                });
            }
        })
    }

}







export async function addErrorListener(callback: CallableFunction) {
    errorListeners.push(callback);
}

export async function addPersistenceListener(callback: CallableFunction) {
    persistenceListeners.push(callback);
    callback(dbPersistence);
}






export async function removeDevicePushId() {
    try {
        var user = await getDoc(doc(db, 'FCMTokens', getCurrentUserUID() + ""));
        var ids = new Map();
        const deviceId = await Device.getId();
        const id: string = deviceId.uuid.replace(/[^a-zA-Z0-9]+/g, '');
        //console.log("id", id);
        if (user !== undefined) {
            var data = user.data();
            if (data !== undefined && data.pushIds !== undefined) {
                var keys = Object.keys(data.pushIds);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i] !== id) {
                        ids.set(keys[i], data.pushIds[keys[i]]);
                    }
                }
                //merge true powoduje ze nawet w map zachowywane sa dane
                await setDoc(doc(db, 'FCMTokens', getCurrentUserUID() + ""), { pushIds: Object.fromEntries(ids) }, { merge: false });
            }
        }
    } catch (error) {
        console.error(error);
        sendError("Nie mozna usunąć FCMTokens!");
    }
    return;
}

export async function updateDevicePushId(pushId: string) {
    try {
        var user = await getDoc(doc(db, 'FCMTokens', getCurrentUserUID() + ""));
        var ids = new Map();
        const deviceId = await Device.getId();

        if (user !== undefined) {
            var data = user.data();
            if (data !== undefined && data.pushIds !== undefined) {
                var keys = Object.keys(data.pushIds);
                for (var i = 0; i < keys.length; i++) {
                    ids.set(keys[i], data.pushIds[keys[i]]);
                }
            }
        }

        ids.set(deviceId.uuid.replace(/[^a-zA-Z0-9]+/g, ''), pushId);
        await setDoc(doc(db, 'FCMTokens', getCurrentUserUID() + ""), { pushIds: Object.fromEntries(ids) }, { merge: true });
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić FCMTokens!");
    }
    return;
}

export async function saveRecordPermissions(collection: string, id:string, permissions: any, updateDate:any){
    
    try {
        var saveData:any = {};
        saveData.permissions = permissions;
        if(updateDate !== undefined && updateDate !== null){
            saveData.lastUpdated = updateDate;
        }
        //console.log("savePermissions", 'companies/' + getCompanyId() + '/'+collection, id, saveData);
        await setDoc(doc(db, 'companies/' + getCompanyId() + '/'+collection, id), saveData, { merge: true });
        sendError("Zapisano uprawnienia!");
    } catch (error) {
        console.error(error);
        sendError("Nie mozna poprawić uprawnień!");
    }
}


export function isValidId(id: any){
    if(id !== undefined  && id !== null && id.length > 3){
        return true;
    }
    return false;
}